// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7e6245ee","977":"4da3ee76"}[chunkId] + ".chunk.js";
};